import * as Yup from 'yup'
import validaCNPJ from 'utils/validaCNPJ'
import i18n from 'i18n'

export const IndustryGroupFormSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required().label(i18n.t('clientGroup:groupName')),
    adminName: Yup.string().required().label(i18n.t('clientGroup:adminName')),
    adminEmail: Yup.string()
      .required()
      .email()
      .label(i18n.t('clientGroup:adminEmail')),
    documentType: Yup.string().required().label(i18n.t('common:documentType')),
    cnpj: Yup.string()
      .required()
      .test('cnpj', i18n.t('inputErrors:invalidCNPJ'), function (value) {
        const { documentType } = this.parent
        if (documentType === 'nacional' && value) {
          const valido = validaCNPJ(value)
          return valido
        } else if (documentType === 'internacional' && value) {
          // Para documentos internacionais, apenas verifica se não está vazio
          return value.length > 0
        }
        return false
      })
      .label(i18n.t('common:identificationCode')),
    visible: Yup.boolean()
      .nullable(true)
      .required()
      .label(i18n.t('clientGroup:view'))
  })
}

export const FilterIndustrySchema = () => {
  return Yup.object().shape({
    name: Yup.string(),
    fancyName: Yup.string(),
    cnpj: Yup.string().label(i18n.t('common:identificationCode'))
  })
}

export const FilterCnpjIndustrySchema = () => {
  return Yup.object().shape({
    name: Yup.string(),
    cnpj: Yup.string()
  })
}
